import { EmptyContent as EmptyContentCore } from '@ztechapps/webui.util'
import React from 'react'

export const PostEmptyContent = () => {
  return (
    <div className="container py-5">
      <EmptyContentCore
        icon="file"
        message="The entry does not exists."
        subMessage="The admin intentionally remove or de-activate this post entry."
      />
    </div>
  )
}
